import React, { useMemo, useState } from 'react';
import { useSearchableProjects } from './useSearchableProjects';

export const cleanSearchTerm = value => value.replace(/['",]+/g, '');

export const mapOptions = projects =>
  projects.map(({ displayText, id }) => ({ key: displayText, value: id }));

export const matchOption = searchProjects => async (_, term) => {
  if (!term) {
    return null;
  }

  const projects = await searchProjects(cleanSearchTerm(term));

  const option = projects.shift();

  if (option) {
    return {
      ...option,
      key: option.displayText
    };
  }

  return null;
};

const withCriteriaProvider = (tag, context) => BaseComponent => ({
  ...props
}) => {
  const { searchCriteria: { criterions = {} } = {} } = props;
  const [selected, setSelected] = useState(criterions[tag] || []);
  const { searchProjects } = useSearchableProjects();
  const value = useMemo(
    () => ({
      options: mapOptions([]),
      matchOption: matchOption(searchProjects),
      selected,
      setSelected,
      suggestions: searchProjects
    }),
    [searchProjects, selected]
  );

  return (
    <context.Provider value={value}>
      <BaseComponent {...props} />
    </context.Provider>
  );
};

const makeCriteriaProvider = (tag, context) =>
  withCriteriaProvider(tag, context);

export default makeCriteriaProvider;
